"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const warning = require("warning");
const DefaultLink = ({ to, href: _, ...rest }) => {
    if (!to) {
        return React.createElement("a", Object.assign({}, rest));
    }
    if (typeof to !== 'string') {
        warning(true, 'Please overide your Link component & pass it into LinkProvider');
        return React.createElement("a", Object.assign({}, rest));
    }
    return React.createElement("a", Object.assign({ href: to }, rest));
};
exports.LinkContext = React.createContext({ Link: DefaultLink });
function LinkProvider({ Link, children, }) {
    return (React.createElement(exports.LinkContext.Provider, { value: { Link } }, children));
}
exports.default = LinkProvider;
//# sourceMappingURL=LinkProvider.js.map